<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form v-on:keypress.enter.prevent="searchExportMaterial" class="form-inline my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รหัสวัตถุดิบ"
                        aria-label="Search"
                        v-model="search.code"/>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    &nbsp
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchExportMaterial">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">วันที่เบิก</th>
                    <th scope="col">รหัสวัตถุดิบ</th>
                    <th scope="col">รายการ</th>
                    <th scope="col">จำนวนเบิก</th>
                    <th scope="col">ผู้เบิก</th>
                    <th scope="col">หมายเหตุ</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in material">
                    <td>{{ data.export_date | moment("DD/MM/YYYY") }}</td>
                    <td>{{ data.materials.code }}</td>
                    <td>{{ data.materials.name }}</td>
                    <td>{{ data.quantity }} {{ data.materials.type_unit }}</td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{ data.reason }}</td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , H:mm:ss") }}</td>
                    <td>
                        <a @click="showExportMaterial(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="material.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getExportMaterialPage">
            </vue-pagination>
        </div>
        <br/>
        <!-- Modal delete -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteExportMaterial">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal edit Data -->
        <b-modal
            hide-footer
            ref="edit_data"
            id="import"
            title="นำออกวัตถุดิบ">
            <div v-if="material_export.materials">
                <b-row sm="10">
                    <b-col sm="4" class="col text-right"
                    ><label>วันที่เบิก</label></b-col>
                    <b-col sm="6"><input
                        class="form-control"
                        type="date"
                        v-model="material_export.export_date"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="10" v-if="material_export.materials">
                    <b-col sm="4" class="col text-right">
                        <label>รหัสวัตถุดิบ</label>
                    </b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="text"
                            v-model="material_export.materials.code" disabled/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="11" v-if="material_export.materials">
                    <b-col sm="4" class="col text-right">
                        <label>รายการ</label>
                    </b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="text"
                            v-model="material_export.materials.name" disabled/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right">
                        <label>จำนวนเบิก</label></b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="number"
                            v-model="material_export.quantity"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right">
                        <label>หมายเหตุ</label>
                    </b-col>
                    <b-col sm="6">
                        <textarea
                            class="form-control"
                            v-model="material_export.reason">
                        </textarea>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <div class="col text-center">
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="saveExportMaterial">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp&nbsp
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            @click="hideEditModal">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
            <!--<pre class="alert alert-primary">{{ material_export }}</pre>-->
        </b-modal>
        <!--<pre class="alert alert-primary">{{ material_export }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment"

export default {
    components: {VuePagination, DatePicker},
    name: "materials-export",
    data() {
        return {
            activeCloseDate: false,
            dateFormat: 'D/MM/YYYY',
            dateOne: '',
            search: {
                code: "",
                date: ""
            },
            id: "",
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        this.$store.dispatch("ExportMaterial/get");
    },
    computed: {
        ...mapState({
            material: state => {
                return state.ExportMaterial.table;
            },
            material_export: state => {
                return state.ExportMaterial.replace_data;
            },
            user: state => {
                return state.Auth.user;
            },
            dataPaginate: state => {
                return state.ExportMaterial.dataPaginate;
            }
        })
    },
    methods: {
        clearDate() {
            this.search.date = "";
        },
        //Modal
        showDeleteModal(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },

        showEditModal(id) {
            this.id = id;
            this.$refs.edit_data.show();
        },
        hideEditModal() {
            this.$refs.edit_data.hide();
        },

        //API
        saveExportMaterial() {
            if (this.material_export.quantity < 1 || this.material_export.quantity > this.material_export.materials.quantity) {
                alert("กรุณาใส่จำนวนที่ถูกต้อง");
            } else {
                let data = {
                    export_date: this.material_export.export_date,
                    material_id: this.material_export.material_id,
                    quantity: this.material_export.quantity,
                    reason: this.material_export.reason,
                    user_id: this.user.id
                };
                this.id = this.material_export.id;
                this.$store.dispatch("ExportMaterial/update", {
                    id: this.id,
                    data: data
                })
                    .then(data => {
                        if (!data) {
                            alert("กรุณาใส่หมายเหตุไม่เกิน 255 ตัวอักษร")
                        } else {
                            this.hideEditModal();
                            this.$store.dispatch("ExportMaterial/get");
                        }
                    });
            }
        },
        deleteExportMaterial() {
            this.$store.dispatch("ExportMaterial/delete", this.id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch("ExportMaterial/get");
            });
        },
        showExportMaterial(id) {
            this.showEditModal(id);
            this.$store.dispatch("ExportMaterial/show", id);
        },
        searchExportMaterial() {
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            this.event_submit = true;
            this.$store.dispatch("ExportMaterial/search", {
                code: this.search.code,
                date: this.search.date
            });
        },
        getExportMaterialPage() {
            const page = this.dataPaginate.current_page;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            if (this.event_submit) {
                this.$store.dispatch("ExportMaterial/search", {
                    page: page,
                    code: this.search.code,
                    date: this.search.date
                });
            } else {
                this.$store.dispatch('ExportMaterial/get', page);
            }
        }

    }
};
</script>

<style lang="scss" scoped>
/*td:nth-of-type(1):before {*/
/*content: "วันที่เบิก";*/
/*}*/
/*td:nth-of-type(2):before {*/
/*content: "รหัสวัตถุดิบ";*/
/*}*/
/*td:nth-of-type(3):before {*/
/*content: "รายการ";*/
/*}*/
/*td:nth-of-type(4):before {*/
/*content: "จำนวนเบิก";*/
/*}*/
/*td:nth-of-type(5):before {*/
/*content: "ผู้เบิก";*/
/*}*/
/*td:nth-of-type(6):before {*/
/*content: "หมายเหตุ";*/
/*}*/
/*td:nth-of-type(7):before {*/
/*content: "วันที่อัพเดตล่าสุด";*/
/*}*/
/*td:nth-of-type(8):before {*/
/*content: "แก้ไข / ลบ";*/
/*}*/
</style>
